import api from 'api'
import { CACHE_TAG_SETTINGS_BILLING_GENERAL_LIST } from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getGeneralBilling: build.query({
      query: () => ({
        url: '/api/settings/billing/general/list',
        method: 'POST',
        body: {},
      }),
      providesTags: [CACHE_TAG_SETTINGS_BILLING_GENERAL_LIST],
    }),
  }),
})

export const { useLazyGetGeneralBillingQuery } = extendedApi
